import { Link } from "react-router-dom";
import { benefits, comparisonData, securityData } from "@/mocks/homeData";
import { mainSiteUrl } from "@/mocks/categories";

const allBlogArticles = [
  {
    path: "/blog/sugargoo-spreadsheet-complete-guide",
    tag: "Ultimate Guide",
    title: "Sugargoo Spreadsheet Complete Guide 2026",
    desc: "Everything you need to know about using Sugargoo Spreadsheet — from getting started to advanced product research strategies.",
    image: "https://readdy.ai/api/search-image?query=Professional%20organized%20workspace%20with%20multiple%20product%20samples%20sneakers%20clothing%20accessories%20arranged%20on%20clean%20white%20desk%20with%20laptop%20displaying%20spreadsheet%20data%20warm%20natural%20lighting%20editorial%20productivity%20scene%20minimalist%20modern%20aesthetic&width=800&height=500&seq=blog-card-01&orientation=landscape",
  },
  {
    path: "/blog/sugargoo-review-2026",
    tag: "Review",
    title: "Sugargoo Review 2026: Is It Legit or a Scam?",
    desc: "Honest, in-depth review covering features, pricing, shipping, safety, and user experience.",
    image: "https://readdy.ai/api/search-image?query=Elegant%20modern%20ecommerce%20product%20photography%20with%20stylish%20leather%20handbag%20designer%20watch%20gold%20jewelry%20on%20marble%20surface%20with%20natural%20lighting%20luxurious%20editorial%20composition%20minimal%20clean%20background%20soft%20warm%20shadows%20professional%20catalog%20style&width=800&height=500&seq=blog-card-02&orientation=landscape",
  },
  {
    path: "/blog/sugargoo-shipping-cost-guide",
    tag: "Shipping",
    title: "Sugargoo Shipping Cost Guide: Cheapest Methods Compared",
    desc: "Complete breakdown of international shipping costs, carrier options, and money-saving strategies.",
    image: "https://readdy.ai/api/search-image?query=Professional%20logistics%20and%20shipping%20concept%20photography%20cardboard%20boxes%20packages%20with%20shipping%20labels%20on%20clean%20white%20desk%20natural%20light%20minimal%20workspace%20modern%20warehouse%20aesthetic%20well%20organized%20parcels%20warm%20editorial%20style&width=800&height=500&seq=blog-card-03&orientation=landscape",
  },
  {
    path: "/blog/sugargoo-coupon-discount-guide",
    tag: "Savings",
    title: "Sugargoo Coupon Codes & Discount Guide 2026",
    desc: "Find the latest coupon codes, discount strategies, and money-saving tips for Sugargoo.",
    image: "https://readdy.ai/api/search-image?query=Stylish%20shopping%20discount%20concept%20photography%20with%20fashion%20accessories%20sunglasses%20scarf%20and%20designer%20wallet%20next%20to%20coupon%20tags%20on%20minimal%20pastel%20pink%20background%20soft%20natural%20lighting%20elegant%20editorial%20style%20clean%20composition&width=800&height=500&seq=blog-card-04&orientation=landscape",
  },
  {
    path: "/blog/sugargoo-warehouse-guide",
    tag: "Warehouse",
    title: "Sugargoo Warehouse Guide: Storage, QC & Processing",
    desc: "Everything about Sugargoo warehouse — storage, quality inspection, and package consolidation.",
    image: "https://readdy.ai/api/search-image?query=Modern%20organized%20warehouse%20interior%20with%20shelves%20of%20packaged%20products%20cardboard%20boxes%20neatly%20stacked%20clean%20bright%20industrial%20space%20with%20natural%20light%20coming%20through%20windows%20professional%20logistics%20environment%20minimal%20design&width=800&height=500&seq=blog-card-05&orientation=landscape",
  },
  {
    path: "/blog/is-sugargoo-legit",
    tag: "Safety",
    title: "Is Sugargoo Legit? Complete Safety Analysis",
    desc: "Thorough investigation into Sugargoo's legitimacy — security, company background, and risk analysis.",
    image: "https://readdy.ai/api/search-image?query=Professional%20security%20and%20trust%20concept%20photography%20with%20gold%20padlock%20on%20clean%20white%20minimal%20desk%20next%20to%20certificate%20documents%20natural%20soft%20lighting%20warm%20atmosphere%20reassuring%20editorial%20style%20modern%20composition&width=800&height=500&seq=blog-card-06&orientation=landscape",
  },
  {
    path: "/blog/sugargoo-spreadsheet-for-beginners",
    tag: "Beginner",
    title: "Sugargoo Spreadsheet for Beginners",
    desc: "Start sourcing products in 10 minutes — no prior experience needed with this step-by-step guide.",
    image: "https://readdy.ai/api/search-image?query=Warm%20inviting%20beginners%20workspace%20with%20open%20laptop%20notebook%20coffee%20cup%20and%20colorful%20sticky%20notes%20on%20clean%20wooden%20desk%20natural%20morning%20light%20streaming%20through%20window%20cozy%20learning%20atmosphere%20minimal%20aesthetic&width=800&height=500&seq=blog-card-07&orientation=landscape",
  },
  {
    path: "/blog/how-to-find-winning-products",
    tag: "Strategy",
    title: "How to Find Winning Products With Sugargoo Spreadsheet",
    desc: "Proven methodology for identifying trending, profitable products before your competitors.",
    image: "https://readdy.ai/api/search-image?query=Fashion%20trend%20research%20workspace%20with%20magazine%20cutouts%20fabric%20swatches%20product%20photos%20and%20analytics%20charts%20on%20clean%20desk%20creative%20mood%20board%20natural%20lighting%20modern%20design%20studio%20aesthetic%20minimal%20editorial%20style&width=800&height=500&seq=blog-card-08&orientation=landscape",
  },
  {
    path: "/blog/sugargoo-spreadsheet-for-dropshipping",
    tag: "Dropshipping",
    title: "Sugargoo Spreadsheet for Dropshipping",
    desc: "How dropshippers leverage the Sugargoo Spreadsheet to scale their store and find products faster.",
    image: "https://readdy.ai/api/search-image?query=Modern%20ecommerce%20dropshipping%20workspace%20with%20laptop%20showing%20online%20store%20dashboard%20surrounded%20by%20product%20samples%20packaging%20materials%20and%20shipping%20boxes%20on%20minimal%20desk%20natural%20lighting%20professional%20home%20office%20aesthetic&width=800&height=500&seq=blog-card-09&orientation=landscape",
  },
  {
    path: "/blog/china-shopping-tips",
    tag: "Tips",
    title: "China Shopping Tips: Smart Sourcing Strategies",
    desc: "Expert tips for navigating Chinese e-commerce platforms and maximizing sourcing value.",
    image: "https://readdy.ai/api/search-image?query=World%20map%20with%20shopping%20icons%20and%20product%20parcels%20scattered%20on%20clean%20desk%20global%20ecommerce%20concept%20photography%20with%20warm%20lighting%20modern%20minimal%20workspace%20international%20shopping%20theme%20editorial%20style&width=800&height=500&seq=blog-card-10&orientation=landscape",
  },
];

export function WhatIsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block text-xs font-semibold text-primary-500 uppercase tracking-wider bg-primary-50 px-3 py-1 rounded-full mb-4">
              Introduction
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">
              What Is Sugargoo Spreadsheet?
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              <strong className="text-foreground-900">Sugargoo Spreadsheet</strong> is a structured product research resource 
              that helps users discover trending products, compare suppliers, organize product information, and improve China 
              shopping efficiency. Whether you are a dropshipper, reseller, or individual buyer, having an organized spreadsheet 
              transforms how you source products from platforms like Taobao, 1688, and Weidian.
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              Instead of spending hours manually searching through thousands of listings, the Sugargoo Spreadsheet 
              provides pre-organized product data, supplier ratings, price comparisons, and shipping estimates — all 
              in one convenient document. It is the tool that seasoned China sourcing experts rely on to stay ahead 
              of market trends and maximize profitability.
            </p>
            <Link
              to="/blog/sugargoo-spreadsheet-complete-guide"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors duration-200"
            >
              Read the Complete Guide <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="bg-background-100 border border-background-200/70 rounded-2xl p-6 md:p-8">
            <h3 className="text-sm font-semibold text-foreground-900 mb-5 text-center">
              With vs Without Sugargoo Spreadsheet
            </h3>
            <div className="overflow-hidden rounded-xl border border-background-200/70">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-background-900">
                    <th className="px-4 py-3 text-left text-xs font-semibold text-background-200">Without Spreadsheet</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-primary-300">With Spreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["Manual searching, hours wasted", "Organized product database, instant access"],
                    ["Slow research, random discovery", "Faster product discovery with filters"],
                    ["Random suppliers, no comparison", "Structured supplier comparison side by side"],
                    ["Poor tracking, lost information", "Easy product management and history"],
                  ].map((row, i) => (
                    <tr key={i} className={i % 2 === 0 ? "bg-background-50" : "bg-background-100"}>
                      <td className="px-4 py-3 text-xs text-foreground-500">
                        <i className="ri-close-circle-line text-red-400 mr-1.5"></i>
                        {row[0]}
                      </td>
                      <td className="px-4 py-3 text-xs text-foreground-700">
                        <i className="ri-checkbox-circle-line text-primary-500 mr-1.5"></i>
                        {row[1]}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function BenefitsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider bg-accent-50 px-3 py-1 rounded-full mb-4">
            Why People Use It
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Why People Use Sugargoo Spreadsheet
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            Thousands of dropshippers and resellers rely on structured spreadsheets to streamline their China sourcing workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="group p-6 bg-background-50 border border-background-200/70 rounded-xl hover:border-accent-200 transition-all duration-200"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-50 group-hover:bg-accent-100 transition-colors duration-200 mb-4">
                <i className={`${item.icon} text-accent-500 text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-500 uppercase tracking-wider bg-primary-50 px-3 py-1 rounded-full mb-4">
            Comparison
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Traditional Research vs Sugargoo Spreadsheet
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            See how structured product research transforms your sourcing efficiency.
          </p>
        </div>

        <div className="overflow-hidden rounded-xl border border-background-200/70 bg-background-50">
          <table className="w-full">
            <thead>
              <tr className="bg-background-900">
                <th className="px-5 py-3.5 text-left text-xs font-semibold text-background-200">Feature</th>
                <th className="px-5 py-3.5 text-left text-xs font-semibold text-background-200">Traditional Research</th>
                <th className="px-5 py-3.5 text-left text-xs font-semibold text-primary-300">Sugargoo Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, i) => (
                <tr key={row.feature} className={`border-t border-background-200/70 ${i % 2 === 0 ? "bg-background-50" : "bg-background-100"}`}>
                  <td className="px-5 py-3.5 text-sm font-medium text-foreground-900">{row.feature}</td>
                  <td className="px-5 py-3.5 text-xs text-foreground-500">{row.traditional}</td>
                  <td className="px-5 py-3.5 text-xs text-primary-600 font-medium">{row.spreadsheet}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="text-center mt-8">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Try Sugargoo Spreadsheet Now <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export function BlogSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider bg-accent-50 px-3 py-1 rounded-full mb-4">
            Latest Guides
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Sugargoo Spreadsheet Learning Center
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            In-depth guides and tutorials to help you master product research and China sourcing.
          </p>
          <Link
            to="/shopping-guide"
            className="inline-flex items-center gap-2 mt-4 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors"
          >
            View All Guides <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {allBlogArticles.map((article) => (
            <Link
              key={article.path}
              to={article.path}
              className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 hover:shadow-md transition-all duration-200"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-2.5 py-1 rounded-full mb-2">{article.tag}</span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">{article.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{article.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TrustSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-secondary-600 uppercase tracking-wider bg-secondary-50 px-3 py-1 rounded-full mb-4">
            Trust &amp; Security
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Why Trust Our Website?
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            We are committed to providing transparent, accurate, and secure content for the China sourcing community.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {securityData.map((item) => (
            <div key={item.area} className="flex gap-4 p-5 bg-background-100 border border-background-200/70 rounded-xl">
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-secondary-50">
                <i className="ri-shield-check-line text-secondary-500 text-lg"></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-1">{item.area}</h4>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.protection}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-foreground-400">
          <span className="flex items-center gap-1.5">
            <i className="ri-lock-line text-secondary-500"></i> SSL Secured
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-user-voice-line text-secondary-500"></i> Independent Resource
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-refresh-line text-secondary-500"></i> Regularly Updated
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-file-text-line text-secondary-500"></i> Transparent Content
          </span>
        </div>
      </div>
    </section>
  );
}

export function CtaSection() {
  return (
    <section className="py-16 md:py-20 bg-background-900">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          Ready to Transform Your Product Research?
        </h2>
        <p className="text-sm text-background-400 max-w-lg mx-auto mb-8">
          Join thousands of dropshippers and resellers who use Sugargoo Spreadsheet to find products faster, compare suppliers smarter, and grow their business.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-900 bg-primary-400 hover:bg-primary-300 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Sugargoo Spreadsheet
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 border border-background-50/30 hover:bg-background-50/10 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}

export function FaqSection() {
  const faqs = [
    {
      q: "What is Sugargoo Spreadsheet?",
      a: "Sugargoo Spreadsheet is a structured product research document that organizes product listings, supplier information, pricing data, and shipping estimates from Chinese e-commerce platforms. It helps dropshippers, resellers, and individual buyers streamline their product sourcing workflow by providing pre-organized data in a ready-to-use format."
    },
    {
      q: "Is Sugargoo Spreadsheet suitable for beginners?",
      a: "Absolutely. The Sugargoo Spreadsheet is designed to be beginner-friendly with a copy-paste ready format. Even if you have never sourced products from China before, the organized structure makes it easy to find products, compare prices, and understand supplier ratings without any prior experience."
    },
    {
      q: "How often is Sugargoo Spreadsheet updated?",
      a: "The spreadsheet is regularly updated to reflect the latest trending products, current pricing, and active supplier information. Product lists are refreshed to ensure you always have access to relevant and profitable items for your business."
    },
    {
      q: "Can I use Sugargoo Spreadsheet for dropshipping?",
      a: "Yes, the Sugargoo Spreadsheet is particularly valuable for dropshippers. It provides organized product data that helps you quickly identify winning products, compare supplier pricing, and make informed sourcing decisions — significantly reducing the time spent on manual product research."
    },
    {
      q: "What platforms are covered in Sugargoo Spreadsheet?",
      a: "The spreadsheet primarily covers products from major Chinese e-commerce platforms including Taobao, 1688, and Weidian. It also includes supplier ratings, shipping options, and pricing comparisons to help you make the best sourcing decisions."
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-500 uppercase tracking-wider bg-primary-50 px-3 py-1 rounded-full mb-4">
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            Common questions about Sugargoo Spreadsheet and China product sourcing.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <span className="text-sm font-semibold text-foreground-900 pr-4">{faq.q}</span>
                <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0"></i>
                <i className="ri-subtract-line text-foreground-400 hidden group-open:block flex-shrink-0"></i>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-xs text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}